import { getPassage } from "../../cpcoc/getPassage";
import { getReadTime } from "../../cpcoc/getReadTime";
import { getReadTimeMsg } from "../../cpcoc/getReadTimeMsg";
import { addCheckingFetch } from "./checkingFetches";
import { getSignal } from "./resetAbortHandling";
const cachedReadingTimes = {};
export function getBibleReadingTime(readingString, selector) {
    if (cachedReadingTimes[readingString]) {
        const initTime = new Date();
        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            // TODO: is this redundant?
            if (element || new Date().valueOf() - initTime.valueOf() > 2000) {
                clearInterval(checkInterval);
            }
            if (element) {
                element.innerHTML = cachedReadingTimes[readingString];
            }
        }, 250);
        return false;
    }
    addCheckingFetch(getPassage({
        outputFormat: "text", // TODO: what does this do?
        passage: readingString,
    }, getSignal())
        .then((d) => {
        cachedReadingTimes[readingString] = getReadTimeMsg(getReadTime(d.passages.join(" ")));
        document.querySelector(selector).innerHTML =
            cachedReadingTimes[readingString];
    })
        .catch((e) => {
        console.error(e.message);
    }));
}
